import { render } from "./cancelZh.vue?vue&type=template&id=2357c4a2&scoped=true"
import script from "./cancelZh.vue?vue&type=script&lang=js"
export * from "./cancelZh.vue?vue&type=script&lang=js"

import "./cancelZh.vue?vue&type=style&index=0&id=2357c4a2&scoped=true&lang=scss"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2357c4a2"]])

export default __exports__